import React from 'react';
import { GiftIcon } from 'lucide-react';
import { Eyebrow } from './Eyebrow';
import { WaitlistForm } from './WaitlistForm';
import { ScarcityCard } from './ScarcityCard';
import { Reveal } from './Reveal';
export function Hero() {
  return <section className="border-b border-white/[0.16] bg-[linear-gradient(160deg,#311a0a_0%,#241308_55%,#180D05_100%)] pb-[90px] pt-[30px]" data-id="element-41">
      <div className="mx-auto max-w-[1100px] px-6" data-id="element-42">
        <div className="mt-[30px] grid grid-cols-1 items-center gap-[50px] lg:grid-cols-[1.2fr_0.8fr]" data-id="element-43">
          <div data-id="element-44">
            <Eyebrow data-id="element-45">LISTA DE ESPERA</Eyebrow>
            <h1 className="max-w-[600px] text-[clamp(36px,5.6vw,60px)] leading-[1.04] text-white" data-id="element-46">
              La proteína que <span className="text-camel" data-id="element-47">no cae pesada</span>.
              En tu desayuno de todos los días.
            </h1>
            <p className="mt-5 max-w-[480px] text-[clamp(15px,1.6vw,17.5px)] font-medium text-white/80" data-id="element-48">
              Cofit es una fórmula propia de proteína funcional, desarrollada y{' '}
              <b className="font-extrabold text-white" data-id="element-49">certificada por ANMAT</b>
              , pensada para tu desayuno de todos los días. Los detalles de la
              fórmula los compartimos primero con la lista de espera.
            </p>
            <div className="mt-6 inline-flex items-center gap-2.5 border border-camel/40 bg-camel/10 px-4 py-2.5" data-id="element-50">
              <GiftIcon className="h-[18px] w-[18px] flex-shrink-0 text-camel-light" aria-hidden="true" data-id="element-51" />
              <p className="text-[13.5px] font-semibold text-white/90" data-id="element-52">
                Regalo de bienvenida exclusivo para los primeros de la lista.
              </p>
            </div>
            <div className="mt-[26px]" data-id="element-53">
              <WaitlistForm variant="hero" submitLabel="QUIERO SER DE LOS PRIMEROS" data-id="element-54" />
            </div>
          </div>

          <Reveal data-id="element-55">
            <ScarcityCard data-id="element-56" />
          </Reveal>
        </div>
      </div>
    </section>;
}